const getUrlParameter = function (url, name) {
	let regex, results;

	name = name.replace(/\[/, '\\[').replace(/[\]]/, '\\]');
	regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	results = regex.exec(url);

	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const setUrlParameter = function (url, name, value) {
	const a = document.createElement('a');
	const regex = /(?:\?|&amp;|&)+([^=]+)(?:=([^&]*))*/g;
	let match;
	const str = [];

	a.href = url;

	name = encodeURIComponent(name);

	while ((match = regex.exec(a.search))) {
		if (name !== match[1]) {
			str.push(match[1] + (match[2] ? '=' + match[2] : ''));
		}
	}

	str.push(name + '=' + (value !== undefined ? encodeURIComponent(value) : ''));

	a.search = str.join('&');

	return a.href;
};

export { getUrlParameter, setUrlParameter };
